import { useModuleBEM } from "@b2bportal/core-themes";
import type { PlatformComponentProps } from "@b2bportal/core-types";
import { Pill, PillTone } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./CarAttributePill.module.scss";
import { useCarsStyles } from "~core-cars/themes";
import { CoreCarsComponent } from "~core-cars/types";

const COMPONENT_KEY = CoreCarsComponent.CarAttributePill;
export type CarAttributePillType = {
  icon?: React.ReactNode;
} & PlatformComponentProps;

export const CarAttributePill = ({
  icon,
  children,
  className,
}: CarAttributePillType) => {
  const styles = useCarsStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <Pill className={clsx(block, className)} icon={icon} tone={PillTone.custom}>
      {children}
    </Pill>
  );
};
